import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy } from '@angular/core';
import { Subscription, map } from 'rxjs';
import { TfaService, UserService } from '@wm-libs/core';
import { User } from '@wm-libs/core';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-toggle-tfa',
  templateUrl: './toggle-tfa.component.html',
  styleUrls: ['./toggle-tfa.component.scss'],
  standalone: true,
  imports: [MatSlideToggleModule, TranslateModule],
})
export class ToggleTfaComponent implements OnDestroy {
  private userSubscription: Subscription;
  userData$!: User | null;

  isTablet$ = this.breakpointObserver.observe([Breakpoints.Small]).pipe(map((result) => result.matches));

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((result) => result.matches));

  isMedium$ = this.breakpointObserver.observe([Breakpoints.Medium]).pipe(map((result) => result.matches));

  constructor(private breakpointObserver: BreakpointObserver, private userService: UserService, private tfaService: TfaService) {
    this.userSubscription = this.userService.userData$.subscribe((status) => {
      this.userData$ = status;
    });
  }

  toggleTFA(event: MatSlideToggleChange) {
    const originalState = !event.checked;

    if (originalState) {
      // TFA is currently enabled, we want to disable it
      if (this.userData$?.tfaEnabled) {
        this.tfaService.disableTfa().subscribe((success) => {
          if (success) {
            event.source.checked = false;
          } else {
            event.source.checked = originalState;
          }
        });
      }
    } else {
      // TFA is currently disabled, we want to enable it
      if (!this.userData$?.tfaEnabled) {
        this.tfaService.enableTfa().subscribe((success) => {
          if (success) {
            event.source.checked = true;
          } else {
            event.source.checked = originalState;
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.userSubscription) this.userSubscription.unsubscribe();
  }
}
